import {LoopableList} from "../../core/utils/LoopableList";

export class KarenSoundConfig {
    public static AS_WIN:string="asWin";
    public static AS_WIN_BIG:string="asWinBig";

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: LoopableList<string> = new LoopableList<string>(["reelLand01", "reelLand02", "reelLand03", "reelLand04", "reelLand05", "reelLand06"]).setRandomizeAtWrapAround(true);
    public static REEL_RESET: string = "reelsReset";
    public static REEL_EXPAND: LoopableList<string> = new LoopableList<string>(["reelExpand01", "reelExpand02", "reelExpand03", "reelExpand04"]).setRandomizeAtWrapAround(true);
    //intro
    public static REEL_EXPAND_INTRO: string = "reelsExpandIntro";

    // Background Music
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static FREESPIN_GAME_MUSIC: string = "fsMainLoop";
    public static MAINGAME_MUSIC_START: string = "mainStart";

    // Freespin Music
    public static FREESPIN_INTRO_LOOP: string = "fsIntroLoop";
    public static FREESPIN_START: string = "fsStart";
    public static FREESPIN_WIN_LOOP: string = "fsWinLoop";
    public static FREESPIN_END: string = "fsEnd";
    public static FREESPIN_END_LOOP: string = "fsEndLoop";

    // BigWin Music
    public static BIG_WIN_LEVEL: string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4", "bigwinLevel4"];
    public static BIG_WIN_MUSIC: string[] = ["bigwinMusic1", "bigwinMusic2", "bigwinMusic3", "bigwinMusic4"];
    public static BIG_WIN_ENDS: string = "bigwinEnds";
    public static BIG_WIN_END_MUSIC: string = "bigwinMusicEnds";
    public static BIG_WIN_END_MUSIC_CAP_WIN = "bigwinMusicEndsCap";

    // BIGWIN Sounds
    static BIGWIN_INTRO = "bigWinIntro";
    static BIGWIN_INTRO_MUSIC = "bigwinMusicIntro";

    static STOP_REEL = "spin-stop";
    static NEWSPAPER_INTRO = "introNewspaper";

    // Countup Music
    static COUNTUP: string = "countup";
    static COUNTUP_ENDS: string[] = ["winTiny", "winSmall", "countupEndsMedium", "countupEndsLarge"];
    static WIN_SOUNDS: string[] = ["winTiny", "winSmall", "winMedium", "winLarge"];

    //CapWin
    static CAP_WIN_COUNTUP: string = "capwinCountup";
    static CAP_WIN_LOOP: string = "capwinLoop";
    static CAP_WIN_END: string = "capwinEnd";

    // Enhanced Button On Off Sound
    static ENHANCED_BET_OFF: string = "enhancedBetOff";
    static ENHANCED_BET_ON: string = "enhancedBetOn";

    // Scatter Sounds
    static SCATTER_LANDING_SOUNDS = ["scatterLand1", "scatterLand2", "scatterLand3", "scatterLand4", "scatterLand1Enhanced"];
    static SCATTER_LAND_FS = "scatterLandFS";
    static SCATTER_TO_XWAYS = "scatterToXways";
    static SCATTER_ANTICIPATION = "scatterAnticipation";
    static SCATTER_ANTICIPATION_FAIL = "scatterAnticipationFail";
    static SCATTER_TRIGGER = "fsIntro";


    // xWays Soundsf
    static X_WAYS_LAND = "xWaysLand";
    static X_WAYS_SHAKE = "xWaysShake";
    static SYM_SHAKE = "xWaysShakeSymbols";
    static X_WAYS_REVEAL = "xWaysReveal";
    static X_WAYS_REVEAL_FAST = "xWaysRevealFast";

    static X_WAYS_STICKY_REVEAL = "xwaysStickyReveal";
    static X_WAYS_STICKY_RESET = "xwaysStickyReset";
    static X_WAYS_STICKY_WIN = "xwaysStickyWin";

    // xWays Infectious Sound
    static xWaysInfectiousSelection = "xwaysInfectiousSelection";
    static xWaysInfectiousRevealWild = "xwaysInfectiousRevealWild";
    static xWaysInfectiousReveal = "xwaysInfectiousReveal";
    static xWaysInfectiousLand = "xwaysInfectiousLand";

    // xNudge Sounds
    static xNudgeLand = "xNudgeLand";
    static xNudgesSounds = ["xNudgeNudge1", "xNudgeNudge2", "xNudgeNudge3", "xNudgeNudge4", "xNudgeNudge5", "xNudgeNudge6", "xNudgeNudge7"];
    static xNudgeNudgeFastWin = "xNudgeNudgeFastWin";
    static xNudgeNudgeFastNoWin = "xNudgeNudgeFastNoWin";
    static xNudgeExplode = "xNudgeNudgeExplode";

    // WIN FRAME SOUNDS
    static WIN_FRAME = ["winFrame1", "winFrame2", "winFrame3", "winFrame4", "winFrame5", "winFrame6"];

    static WILD_NUDGE_ANTICIPATION = "xNudgeAnticipation";
    static WILD_NUDGE_ANTICIPATION_END = "xNudgeAnticipationEnd"

    // Multiplier Sound
    static MULTIPLIER_STAMP: LoopableList<string> = new LoopableList<string>(["multiplierStamp01", "multiplierStamp02", "multiplierStamp03", "multiplierStamp04", "multiplierStamp05", "multiplierStamp06"]).setRandomizeAtWrapAround(true);
    static MULTIPLIER_UP = "multiplierUp";
}
